<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21">
        <path fill="#FAF5FC" :stroke="color" d="M12 1.092L8.8 7.308l-7.105.989 5.139 4.8-1.219 6.81L12 16.69l6.385 3.217-1.219-6.81 5.139-4.8-7.104-.99L12 1.093z"/>
    </svg>
</template>

<script>
export default {
    name: 'star-active-icon',
    props: {
        color: {
            type: String,
            default: '#833e93'
        }
    }
}
</script>
